import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/login',
      component: resolve => require(['../components/Login.vue'], resolve),
      meta: { requiresAuth: false }
    },
    {
      path: '/403',
      component: resolve => require(['../components/403.vue'], resolve),
      meta: { requiresAuth: false }
    },
    {
      path: '/401.1/:error',
      component: resolve => require(['../components/4011.vue'], resolve),
      meta: { requiresAuth: false }
    },
    // 零件管理看板
    {
      path: '/partManagePanel',
      component: resolve => require(['../components/partManagePanel/index.vue'], resolve),
      meta: { requiresAuth: true, permission: 'PARTS_MANAGE_KANBAN' },
      children: [
        // 零件管理
        {
          path: '',
          name: 'partManagePanel',
          component: resolve => require(['../components/partManagePanel/partManage.vue'], resolve),
          meta: { requiresAuth: true, title: '零件处管理驾驶仓' }
        },
        // 注塑可视化管理
        {
          path: 'injectionVisualization',
          name: 'injectionVisualization',
          component: resolve => require(['../components/partManagePanel/visualization.vue'], resolve),
          meta: { requiresAuth: true, title: '注塑可视化管理看板',type:1 }
        },
        // 注塑生产运营
        {
          path: 'injectionOperation',
          name: 'injectionOperation',
          component: resolve => require(['../components/partManagePanel/operation.vue'], resolve),
          meta: { requiresAuth: true, title: '注塑生产运营看板',type:1 }
        },
        // 冲压可视化管理
        {
          path: 'stampingVisualization',
          name: 'stampingVisualization',
          component: resolve => require(['../components/partManagePanel/visualization.vue'], resolve),
          meta: { requiresAuth: true, title: '冲压可视化管理看板',type:2 }
        },
        // 冲压生产运营
        {
          path: 'stampingOperation',
          name: 'stampingOperation',
          component: resolve => require(['../components/partManagePanel/operation.vue'], resolve),
          meta: { requiresAuth: true, title: '冲压生产运营看板',type:2 }
        }
      ]
    },
    {
      path: '/',
      component: resolve => require(['../components/Main.vue'], resolve),
      meta: { requiresAuth: true },
      children: [
        {
          path: "/wms/sparePartsInAdd",
          component: resolve =>
            require(["../components/wms/sparePartsIn/sparePartsInAdd.vue"], resolve),
          meta: { requiresAuth: true, permission: "WMS_SPARE_PARTS_IN_ADD" }
        }, //备件入库_add
        {
          path: "/wms/sparePartsInList",
          component: resolve =>
            require(["../components/wms/sparePartsIn/sparePartsInList.vue"], resolve),
          meta: { requiresAuth: true, permission: "WMS_SPARE_PARTS_IN" }
        }, //备件入库_list
        {
          path: "/wms/sparePartsTakeAdd",
          component: resolve =>
            require(["../components/wms/sparePartsTake/sparePartsTakeAdd.vue"], resolve),
          meta: { requiresAuth: true, permission: "WMS_SPARE_PARTS_TAKE_ADD" }
        }, //备件出库_add
        {
          path: "/wms/sparePartsTakeList",
          component: resolve =>
            require(["../components/wms/sparePartsTake/sparePartsTakeList.vue"], resolve),
          meta: { requiresAuth: true, permission: "WMS_SPARE_PARTS_TAKE" }
        }, //备件出库_list
        {
          path: '/scm/purchaseApplyList',
          component: resolve => require(['../components/scm/apply/purchaseApplyList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SCM_PURCHASE_APPLY' } //
        }, //采购申请lIST
        {
          path: '/scm/purchaseApplyAdd',
          component: resolve => require(['../components/scm/apply/purchaseApply.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SCM_PURCHASE_APPLY_ADD' }
        }, //采购申请
        {
          path: '/scm/purchaseEnquiryList',
          component: resolve => require(['../components/scm/enquiry/purchaseEnquiryList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SCM_PURCHASE_ENQUIRY' } //
        }, //采购询价lIST
        {
          path: '/scm/purchaseEnquiryAdd',
          component: resolve => require(['../components/scm/enquiry/purchaseEnquiry.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SCM_PURCHASE_ENQUIRY_ADD' }
        }, //采购询价
        {
          path: '/scm/purchaseOrderList',
          component: resolve => require(['../components/scm/order/purchaseOrderList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SCM_PURCHASE_ORDER' } //
        }, //采购订单lIST
        {
          path: '/scm/purchaseOrderAdd',
          component: resolve => require(['../components/scm/order/purchaseOrder.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SCM_PURCHASE_ORDER_ADD' }
        }, //采购订单
        {
          path: '/wms/bomTakeList',
          component: resolve => require(['../components/wms/bomTake/bomTakeList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_BOM_TAKE' } //
        }, //BOM出库列表
        {
          path: '/wms/bomTakeAdd',
          component: resolve => require(['../components/wms/bomTake/bomTakeAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_BOM_TAKE_ADD' } //
        }, //BOM出库新增
        {
          path: '/wms/transferList',
          component: resolve => require(['../components/wms/transfer/transferInList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_TRANSFER_IN' }
        }, //调拨入库列表
        {
          path: '/wms/transferAdd',
          component: resolve => require(['../components/wms/transfer/transferInAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_TRANSFER_IN_ADD' }
        }, //调拨入库新增
        {
          path: '/wms/scrapInList',
          component: resolve => require(['../components/wms/scrapIn/scrapInList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_SCRAP_IN' }
        }, //报废入库列表
        {
          path: '/wms/scrapInAdd',
          component: resolve => require(['../components/wms/scrapIn/scrapInAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_SCRAP_IN_ADD' }
        }, //报废入库新增
        {
          path: '/wms/stockMonthList',
          component: resolve => require(['../components/wms/stockMonth/stockMonthList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_STOCK_MONTH' }
        }, //月结列表
        {
          path: '/wms/stockMonthAdd',
          component: resolve => require(['../components/wms/stockMonth/stockMonthAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_STOCK_MONTH_ADD' }
        }, //月结新增
        {
          path: '/wms/otherInAdd',
          component: resolve => require(['../components/wms/otherIn/otherInAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_OTHER_IN_ADD' }
        }, //其他入库_add
        {
          path: '/wms/otherInList',
          component: resolve => require(['../components/wms/otherIn/otherInList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_OTHER_IN' }
        }, //其他入库_list
        {
          path: '/wms/otherTakeAdd',
          component: resolve => require(['../components/wms/otherTake/otherTakeAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_OTHER_TAKE_ADD' }
        }, //其他领料_add
        {
          path: '/wms/otherTakeList',
          component: resolve => require(['../components/wms/otherTake/otherTakeList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_OTHER_TAKE' }
        }, //其他领料_list
        {
          path: '/wms/otherReturnAdd',
          component: resolve => require(['../components/wms/otherReturn/otherReturnAdd.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_OTHER_RETURN_ADD' }
        }, //其他退料_add
        {
          path: '/wms/otherReturnList',
          component: resolve => require(['../components/wms/otherReturn/otherReturnList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_OTHER_RETURN' }
        }, //其他退料_list
        {
          path: '/wms/stockQuery',
          component: resolve => require(['../components/wms/stockQuery/stockQuery.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_STOCK_QUERY' }
        }, //库存查询
        {
          path: '/wms/stockSpareQuery',
          component: resolve => require(['../components/wms/stockQuery/stockSpareQuery.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_STOCK_QUERY' }
        }, //库存查询
        {
          path: '/wms/stockDetail',
          component: resolve => require(['../components/wms/stockQuery/stockDetailQuery.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WMS_STOCK_QUERY' }
        }, //库存查询

        {
          // 手动排程
          path: '/scheduling',
          name: 'Scheduling',
          component: resolve => require(['../components/scheduling/index.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          // 手动排程
          path: '/managePlan',
          name: 'managePlan',
          component: resolve => require(['../components/managePlan/index.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/order',
          component: resolve => require(['../components/order/OrderManage.vue'], resolve),
          meta: { requiresAuth: true, permission: 'WORK_ORDER' }
        },
        {
          path: '/bom',
          component: resolve => require(['../components/bom/BomList.vue'], resolve),
          meta: { requiresAuth: true, permission: 'PRODUCE_BOM' }
        },
        {
          path: '/newProcess',
          component: resolve => require(['../components/technology/Library.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/process',
          component: resolve => require(['../components/process/ProcessManage.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/unscheduledProcess',
          component: resolve => require(['../components/process/unscheduledProcess/UnscheduledProcess.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/printProcessCard',
          component: resolve => require(['../components/process/scheduledProcess/PrintProcessCard.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/plan',
          component: resolve => require(['../components/plan/PlanManage.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/plan/outsideProcess/OutsideProcess',
          component: resolve => require(['../components/plan/outsideProcess/OutsideProcess.vue'], resolve),
          meta: { requiresAuth: true, permission: 'PROGRESS_MANAGE_OUTSIDE' }
        },
        {
          path: '/plan/CapacityLoad',
          component: resolve => require(['../components/plan/CapacityLoad.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/plan/CycleSchedule',
          component: resolve => require(['../components/plan/cycleSchedule/CycleSchedule.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/plan/requirementsManagement',
          component: resolve => require(['../components/plan/RequirementsManagement.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/newReport1',
          component: resolve => require(['../components/newReport1/index.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/report',
          component: resolve => require(['../components/report/report.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/maintenance',
          component: resolve => require(['../components/maintenance/index.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/moldReportingManagement',
          component: resolve => require(['@/components/moldReportingManagement/index.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/newReportV2',
          component: resolve => require(['@/components/newReportV2/index.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/quality',
          component: resolve => require(['../components/quality/QualityList.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/newQuality',
          component: resolve => require(['../components/newQuality/index.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/quality/punish',
          component: resolve => require(['../components/quality/QualityPenalty.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/quality/testing',
          component: resolve => require(['../components/quality/qualityTesting/Report.vue'], resolve),
          meta: { requiresAuth: true, permission: '' }
        },
        {
          path: '/system/loginLog',
          component: resolve => require(['../components/loginLog/index.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/system/basic',
          component: resolve => require(['../components/system/Basic.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_BASIC' },
          children: [
            {
              path: 'materiel',
              component: resolve => require(['../components/system/basic/materiel/MaterielMasterCope.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_MATERIEL' }
            },
            // {
            //   path: "materiel",
            //   component: resolve =>
            //     require([
            //       "../components/system/basic/materiel/MaterielMaster.vue"
            //     ], resolve),
            //   meta: { requiresAuth: true, permission: "SYSTEM_MATERIEL" }
            // },
            {
              path: 'customer',
              component: resolve => require(['../components/system/basic/Customer.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_CUSTOM' }
            },
            {
              path: 'outsideFactory',
              component: resolve => require(['../components/system/basic/outsideFactory/OutsideFactory.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'SYSTEM_BASIC_OUTSIDE_FACTORY'
              }
            },
            {
              path: 'factory',
              component: resolve => require(['../components/system/basic/Factory.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_FACTORY' }
            },
            {
              path: 'department',
              component: resolve => require(['../components/system/basic/Department.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'SYSTEM_BASIC_DEPARTMENT'
              }
            },
            {
              path: 'department/edit/:pid/:id',
              component: resolve => require(['../components/system/basic/DepartmentEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_DEPARTMENT_ADD', 'SYSTEM_BASIC_DEPARTMENT_MODIFY']
              }
            },
            {
              path: 'role',
              component: resolve => require(['../components/system/basic/Role.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_ROLE' }
            },
            {
              path: 'role/edit/:id',
              component: resolve => require(['../components/system/basic/RoleEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_ROLE_ADD', 'SYSTEM_BASIC_ROLE_MODIFY']
              }
            },
            {
              path: 'employee',
              name: 'employee',
              component: resolve => require(['../components/system/basic/Employee.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_EMPLOYEE' }
            },
            {
              path: 'employee/edit/:id',
              component: resolve => require(['../components/system/basic/EmployeeEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_EMPLOYEE_ADD', 'SYSTEM_BASIC_EMPLOYEE_MODIFY']
              }
            },
            {
              path: 'device',
              component: resolve => require(['../components/system/basic/Device.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_DEVICE' }
            },
            {
              path: 'device/edit/:id',
              component: resolve => require(['../components/system/basic/DeviceEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_DEVICE_ADD', 'SYSTEM_BASIC_DEVICE_MODIFY']
              }
            },
            {
              path: 'group',
              component: resolve => require(['../components/system/basic/Group.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_GROUP' }
            },
            {
              path: 'group/edit/:id',
              component: resolve => require(['../components/system/basic/GroupEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_GROUP_ADD', 'SYSTEM_BASIC_GROUP_MODIFY']
              }
            },
            {
              path: 'crafts/:type',
              component: resolve => require(['../components/system/basic/Crafts.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_PROCESS' }
            },
            {
              path: 'crafts/edit/:type/:id',
              component: resolve => require(['../components/system/basic/CraftsEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_PROCESS_ADD', 'SYSTEM_BASIC_PROCESS_MODIFY']
              }
            },
            {
              path: 'productionLine',
              component: resolve => require(['../components/system/basic/ProductionLine.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'SYSTEM_BASIC_PRODUCTION_LINE'
              }
            },
            {
              path: 'productionLine/edit/:id',
              component: resolve => require(['../components/system/basic/ProductionLineEdit.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_PRODUCTION_LINE_ADD', 'SYSTEM_BASIC_PRODUCTION_LINE_MODIFY']
              }
            },
            {
              path: 'costType',
              component: resolve => require(['../components/system/basic/CostType.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_COST_TYPE' }
            },
            {
              path: 'shelf',
              component: resolve => require(['../components/system/basic/Shelf.vue'], resolve),
              meta: { requiresAuth: true, permission: 'SYSTEM_BASIC_SHELF' }
            },
            {
              path: 'order/node',
              component: resolve => require(['../components/system/basic/OrderPlanNodeSetting.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'ORDER_MASTER_PLAN_NODE_SETTING'
              }
            },
            {
              path: 'formula',
              component: resolve => require(['../components/system/basic/FormulaList.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['SYSTEM_BASIC_FORMULA']
              }
            },
            {
              path: 'cycleScheduleSetting',
              component: resolve => require(['../components/system/basic/CycleScheduleSetting.vue'], resolve),
              meta: {
                requiresAuth: true,
                permissions: ['WORK_PLAN_CYCLE_SCHEDULE']
              }
            },
            {
              path: 'materialColumnMapping',
              component: resolve =>
                require(['../components/system/basic/materialColumnMapping/materialColumnMapping.vue'], resolve),
              meta: { requiresAuth: true, permissions: ['MAT_COLUMN_MAPPING'] }
            },
            {
              path: 'costShareSetting',
              component: resolve => require(['../components/system/basic/costShare/CostShareSetting.vue'], resolve),
              meta: { requiresAuth: false }
            },
            {
              path: 'task',
              component: resolve => require(['../components/system/basic/task/Task.vue'], resolve),
              meta: { requiresAuth: false }
            },
            {
              path: 'store',
              component: resolve => require(['../components/system/basic/Store.vue'], resolve),
              meta: { requiresAuth: false }
            },

            {
              path: 'parameter',
              component: resolve => require(['../components/system/basic/parameter/parameter.vue'], resolve),
              meta: { requiresAuth: false }
            },

            //添加供应商
            {
              path: 'Supplier',
              name: 'Supplier',
              component: resolve => require(['../components/system/basic/Supplier/Supplier.vue'], resolve),
              meta: { requiresAuth: true }
            },
            {
              path: 'numericalControl',
              name: 'NumericalControlManage',
              component: resolve => require(['../components/iot/base/NumericalControlParamManage.vue'], resolve),
              meta: { requiresAuth: true }
            },
            // 维保作业设置

            {
              path: 'maintenance',
              component: resolve => require(['../components/system/basic/maintenance/maintenance.vue'], resolve),
              meta: {
                requiresAuth: true
              }
            },

            {
              //仓库审批
              path: 'CheckFlow',
              name: 'CheckFlow',
              component: resolve => require(['../components/system/basic/CheckFlow.vue'], resolve),
              meta: { requiresAuth: true }
            },
            {
              //系统审批设置
              path: 'examineAndApprove',
              name: 'examineAndApprove',
              component: resolve => require(['../components/system/basic/examineAndApprove.vue'], resolve),
              meta: { requiresAuth: true }
            },
            //单据设置
            {
              path: 'BillSet',
              name: 'BillSet',
              component: resolve => require(['../components/system/basic/BillSet.vue'], resolve),
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: '/system/masterPlanTemplate',
          component: resolve => require(['../components/system/OrderPlanTemplate.vue'], resolve),
          meta: {
            requiresAuth: true,
            permission: 'ORDER_PLAN_TEMPLATE_SETTING'
          }
        },
        {
          path: '/system/classify',
          component: resolve => require(['../components/system/Classify.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_CLASSIFY' }
        },
        {
          path: '/system/job',
          component: resolve => require(['../components/system/Job.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_JOB' }
        },

        {
          path: '/system/classTable',
          component: resolve => require(['../components/system/ClassTable.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_CLASS_TABLE_SETTING' }
        },
        {
          path: '/system/holiday',
          component: resolve => require(['../components/system/HolidaySetting.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_HOLIDAY_SETTING' }
        },
        {
          path: '/process/library',
          component: resolve => require(['../components/process/library/LibraryMain.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_STANDARD_LIB' }
        },
        {
          path: '/process/newLibrary',
          component: resolve => require(['../components/process/newLibrary/LibraryMain.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_STANDARD_LIB' }
        },
        {
          path: '/system/offlineFile',
          component: resolve => require(['../components/system/OfflineFileList.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/system/offlineFile/edit/:id',
          component: resolve => require(['../components/system/OfflineFileEdit.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/system/reportSetting',
          component: resolve => require(['../components/system/reportSetting.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/system/column',
          component: resolve => require(['../components/system/Column.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_CUSTOM_COLUMN' },
          children: [
            {
              path: 'order',
              component: resolve => require(['../components/system/column/OrderColumnSet.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'SYSTEM_CUSTOM_COLUMN_ORDER'
              }
            },
            {
              path: 'part',
              component: resolve => require(['../components/system/column/PartColumnSet.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'SYSTEM_CUSTOM_COLUMN_PART'
              }
            },
            {
              path: 'process',
              component: resolve => require(['../components/system/column/ProcessColumnSet.vue'], resolve),
              meta: {
                requiresAuth: true,
                permission: 'SYSTEM_CUSTOM_COLUMN_PART'
              }
            }
          ]
        },
        {
          path: '/process/transferPartAndProcess',
          component: resolve => require(['../components/process/Import.vue'], resolve),
          meta: { requiresAuth: false }
        },
        // 报表 - 员工日报明细
        {
          path: '/forms/employee/daily/details',
          component: resolve => require(['../components/forms/EmployeeDailyDetails.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 报表 - 员工绩效
        {
          path: '/forms/workshop/employeePerformance',
          component: resolve => require(['../components/forms/workshop/EmployeePerformance.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 报表 - 作业组任务量报表
        {
          path: '/forms/workshop/taskQuantityReportOfGroup',
          component: resolve => require(['../components/forms/workshop/TaskQuantityReportOfGroup.vue'], resolve),
          meta: { requiresAuth: false }
        },
        // 报表 - 工时比对分析报表
        {
          path: '/forms/workshop/workingHoursAnalysisTable',
          component: resolve => require(['../components/forms/workshop/WorkingHoursAnalysisTable.vue'], resolve),
          meta: { requiresAuth: false }
        },
        // 设备维保报表
        {
          path: '/forms/maintenance',
          component: resolve => require(['../components/forms/maintenance.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 设备点检月度报表
        {
          path: '/forms/inspection',
          component: resolve => require(['../components/forms/inspection/index.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 设备保养统计表
        {
          path: '/forms/upkeep',
          component: resolve => require(['../components/forms/upkeep/index.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 质量报表-曾超
        {
          path: '/forms/quality/report/form',
          component: resolve => require(['../components/forms/QualityReportForm.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件报废成本统计报表
        {
          path: '/forms/quality/report/form2',
          component: resolve => require(['../components/forms/QualityReportForm2.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 质量分析报表-曾超
        {
          path: '/forms/quality/analysis/Report',
          component: resolve => require(['../components/forms/QualityAnalysisReport.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 加工中报表 - 袁望城
        {
          path: '/forms/process/machining/details',
          component: resolve => require(['../components/forms/ProcessInMachining.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 报表 - 实际汇总管理零件查询 - 袁宏宇
        {
          path: '/forms/cost/management/summary',
          component: resolve => require(['../components/forms/PerformanceSummary.vue'], resolve),
          meta: { requiresAuth: true }
        },
        //实绩明细成本- 袁望城
        {
          path: '/forms/cost/report/details',
          component: resolve => require(['../components/forms/ReportCostDetails.vue'], resolve),
          meta: { requiresAuth: true }
        },
        //成本科目报表   - 袁望城
        {
          path: '/forms/subject/cost/details',
          component: resolve => require(['../components/forms/SubjectCostDetails.vue'], resolve),
          meta: { requiresAuth: true }
        },
        //零件工序进度报表   - 袁望城
        {
          path: '/forms/partProcess/schedule',
          component: resolve => require(['../components/forms/PartProcessSchedule.vue'], resolve),
          meta: { requiresAuth: true }
        },
        //设备日报明细   - 袁望城
        {
          path: '/forms/device/daily/details',
          component: resolve => require(['../components/forms/DeviceDailyDetails.vue'], resolve),
          meta: { requiresAuth: true }
        },
        //员工报工异常预警   - 袁望城
        {
          path: '/forms/employee/abnormal/alert',
          component: resolve => require(['../components/forms/EmployeeAbnormalAlert.vue'], resolve),
          meta: { requiresAuth: true }
        },
        //零件进度情况表   - 袁望城
        {
          path: '/forms/part/warehouse/status',
          component: resolve => require(['../components/forms/PartWarehouseStatusAnalysis.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 员工工资明细
        {
          path: '/forms/employee/salary/details',
          component: resolve => require(['../components/forms/EmployeeSalaryDetails.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 瑞丽成本分摊报表
        {
          path: '/forms/share/cost/details',
          component: resolve => require(['../components/forms/ShareCostDetails.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '公用成本分摊结算表(月)',
        {
          path: '/forms/orderCostStatement/costAllocationStatement',
          component: resolve =>
            require(['../components/forms/orderCostStatement/CostAllocationStatement.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '分摊费用率结算表(月)',
        {
          path: '/forms/orderCostStatement/costSharingRateStatement',
          component: resolve =>
            require(['../components/forms/orderCostStatement/CostSharingRateStatement.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '工单完工成本结算表(月)'
        {
          path: '/forms/orderCostStatement/orderCostStatement',
          component: resolve => require(['../components/forms/orderCostStatement/OrderCostStatement.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件注塑成型表
        {
          path: '/forms/PartsInjectionMolding',
          component: resolve => require(['../components/forms/reportForm/PartsInjectionMolding.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部冲压架模参数记录表
        {
          path: '/forms/ParameterRecordTable',
          component: resolve => require(['../components/forms/reportForm/ParameterRecordTable.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部冲压首件检验报告
        {
          path: '/forms/FirstPieceInspection',
          component: resolve => require(['../components/forms/reportForm/FirstPieceInspection.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部冲压巡检检验报告
        {
          path: '/forms/StampingInspection',
          component: resolve => require(['../components/forms/reportForm/StampingInspection.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部注塑首次检验报告
        {
          path: '/forms/InjectionFirstInspection',
          component: resolve => require(['../components/forms/reportForm/InjectionFirstInspection.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部注塑巡检检验报告
        {
          path: '/forms/InjectionInspection',
          component: resolve => require(['../components/forms/reportForm/InjectionInspection.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部注塑入库抽检报表
        {
          path: '/forms/warehouseForm',
          component: resolve => require(['../components/forms/reportForm/warehouseForm.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部注塑清换线点检报表
        {
          path: '/forms/clearReplaceLineTable',
          component: resolve => require(['../components/forms/reportForm/clearReplaceLineTable.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部冲压清换线点检报表
        {
          path: '/forms/clearReplaceLineYaTable',
          component: resolve => require(['../components/forms/reportForm/clearReplaceLineYaTable.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部注塑首件检验申请单
        {
          path: '/forms/injectionMoldCheck',
          component: resolve => require(['../components/forms/reportForm/injectionMoldCheck.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部冲压首件检验申请单
        {
          path: '/forms/injectionMoldCheckYa',
          component: resolve => require(['../components/forms/reportForm/injectionMoldCheckYa.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部注塑模具维修保养记录报表
        {
          path: '/forms/maintenanceTable',
          component: resolve => require(['../components/forms/reportForm/maintenanceTable.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 零件部冲压模具维修保养记录报表
        {
          path: '/forms/maintenanceTableYa',
          component: resolve => require(['../components/forms/reportForm/maintenanceTableYa.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 设备维修保养记录报表
        {
          path: '/forms/deviceUpkeep',
          component: resolve => require(['../components/forms/reportForm/deviceUpkeep.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // 冲压赋码报表
        {
          path: "/forms/codingYaForm",
          component: resolve =>
            require([
              "../components/forms/codingYaForm.vue"
            ], resolve),
          meta: { requiresAuth: true }
        },
         // 注塑赋码报表
        {
          path: "/forms/codingForm",
          component: resolve =>
            require([
              "../components/forms/codingForm.vue"
            ], resolve),
          meta: { requiresAuth: true }
        },
         // SPC管制图（CPK）
        {
          path: "/forms/CPKForm",
          component: resolve =>
            require([
              "../components/forms/CPKForm.vue"
            ], resolve),
          meta: { requiresAuth: true }
        },
        // OEE报表
        {
          path: "/forms/OEEForm",
          component: resolve =>
            require([
              "../components/forms/OEEForm/index.vue"
            ], resolve),
          meta: { requiresAuth: true }
        },
        // '文控报表--图纸回收'
        {
          path: '/forms/documentControl/drawingRecycling',
          component: resolve => require(['../components/forms/documentControl/DrawingRecycling.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '计划报表--工单任务报表'
        {
          path: '/forms/plan/orderTaskReport',
          component: resolve => require(['../components/forms/plan/OrderTaskReport.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '计划报表--零件任务报表'
        {
          path: '/forms/plan/partTaskReport',
          component: resolve => require(['../components/forms/plan/PartTaskReport.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '成本报表--内制成本'
        {
          path: '/forms/cost/internalCost',
          component: resolve => require(['../components/forms/orderCostStatement/InternalCostReportForm.vue'], resolve),
          meta: { requiresAuth: true }
        },
        // '成本报表--财务报表'
        {
          path: '/forms/cost/finance',
          component: resolve => require(['../components/forms/orderCostStatement/FinanceReportForm.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/forms/iot/dataAcquisition',
          component: resolve => require(['../components/iot/monitor/dataAcquisition.vue'], resolve),
          meta: { requiresAuth: true }
        },
        {
          path: '/log',
          component: resolve => require(['../components/log/LogManage.vue'], resolve),
          meta: { requiresAuth: true, permission: 'SYSTEM_LOG' }
        },
        {
          path: '/center',
          component: resolve => require(['../components/center/PersonalCenter.vue'], resolve),
          meta: { requiresAuth: true }
        }
      ]
    },
    // 设备联网
    {
      path: '/forms/iot/deviceNetworking',
      name: 'forms/iot/deviceNetworking',
      component: resolve => require(['../components/iot/monitor/DeviceNetworking.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/forms/iot/deviceNetworkingDetail',
      name: 'forms/iot/deviceNetworkingDetail',
      component: resolve => require(['../components/iot/monitor/DeviceNetworkingDetail.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/largeScreenReportForm',
      name: 'largeScreenReportForm',
      component: resolve => require(['../components/largeScreenReportForm/LargeScreenReportForm.vue'], resolve),
      meta: { requiresAuth: true }
    },
    // 大屏

    {
      path: '/largeScreenReportForm1',
      name: 'largeScreenReportForm1',
      component: resolve => require(['../components/largeScreenReportForm/LargeScreenReportForm1.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/largeScreenReportFormIot1',
      name: 'largeScreenReportFormIot1',
      component: resolve => require(['../components/iot/monitor/DeviceMonitor.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/progress',
      name: 'progress',
      component: resolve => require(['../components/progress/ProgressManage.vue'], resolve),
      meta: { requiresAuth: true, permission: 'WORK_ORDER' }
    },
    {
      path: '*',
      component: resolve => require(['../components/404.vue'], resolve),
      meta: { requiresAuth: false }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js